module.exports = __webpack_public_path__ + "img/29.fe0f6c3a.png";